import React from "react";

const SearchIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      {/* <path fill="#fff" d="M0 0H24V24H0z" /> */}
      <g stroke="#2a2e43" strokeLinecap="round">
        <g fill="#fff" transform="translate(6 6)">
          <circle cx="5.5" cy="5.5" r="5.5" stroke="none" />
          <circle cx="5.5" cy="5.5" r="5" fill="none" />
        </g>
        <path
          fill="none"
          d="M0 0L3 3"
          transform="translate(6 6) translate(9 9)"
        />
      </g>
    </svg>
  );
};

export default SearchIcon;
